<template>
  <page-list
    :list="list"
    :columns="templateListColumns || columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :export-data-options="exportDataOptions"
    :show-group-actions="showGroupActions"
    :show-single-actions="!isTemplate"
    :show-page="!isTemplate" />
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import { PROCESS_TYPES_OPTS } from '@/constants/workflow'
import ResTemplateListMixin from '@/mixins/resTemplateList'
import GlobalSearchMixin from '@/mixins/globalSearch'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import { statusMap } from '../../constants'
import { getInternalResourceFilters } from '../../utils'

export default {
  name: 'MeProcessList',
  mixins: [WindowsMixin, ListMixin, GlobalSearchMixin, ColumnsMixin, SingleActionsMixin, ResTemplateListMixin],
  props: {
    id: String,
    listId: String,
    getParams: {
      type: Object,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.listId || this.id,
        resource: 'historic-process-instances',
        apiVersion: 'v1',
        getParams: this.getParam,
        sortKeys: ['create_time'],
        filterOptions: {
          id: {
            label: this.$t('common_350'),
          },
          status: {
            label: this.$t('common.status'),
            dropdown: true,
            items: Object.keys(statusMap).map((v) => {
              return {
                label: statusMap[v],
                key: v,
              }
            }),
          },
          process_definition_key: {
            label: this.$t('common_375'),
            dropdown: true,
            items: PROCESS_TYPES_OPTS.map((v) => {
              return {
                label: v.name,
                key: v.value,
              }
            }),
          },
          ...getInternalResourceFilters(),
        },
        genParamsCb: (params) => {
          return {
            ...params,
            details: false,
          }
        },
        isTemplate: this.isTemplate,
        templateLimit: this.templateLimit,
      }),
      groupActions: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    exportDataOptions () {
      return {
        downloadType: 'local',
        items: this.columns,
      }
    },
  },
  created () {
    this.initSidePageTab('me-process-detail')
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        ...this.getParams,
        user_id: this.userInfo.id,
        process_definition_key_exclude: 'customer-service',
      }
      ret.filter = ret.filter ? (Array.isArray(ret.filter) ? ret.filter : [ret.filter]) : []
      if (ret.project_id) {
        ret.filter.push(`variables->project.equals(${ret.project_id})`)
        delete ret.project_id
      }
      if (ret.domain_id) {
        ret.filter.push(`variables->project_domain.equals(${ret.domain_id})`)
        delete ret.domain_id
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'MeProcessSidePage', {
        id: row.id,
        resource: 'historic-process-instances',
        apiVersion: 'v1',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
